// Third party libraries
import _ from 'lodash';

// Utils & Config
import AxiosService from '../utils/AxiosService';
import Config from '../config';

export interface CredentialsInterface {
    email: string;
    password: string;
    remember?: boolean;
};

export interface Schedule {
    key: string,
    day: string,
    time: string
}

export interface Modality {
    key: string,
    price: number,
    modality: string
}

export interface AffiliationRequest {
    createdAt: string;
    modality: string;
    message: string;
    userId: string;
    status: string;
    user: {
        _id: string,
        name: string,
        surname: string,
        pictureUrl: string
    }
}

export interface DirectoryConfig {
    _id: string;
    createdAt: string;
    updatedAt: string;
    refundPercent: number;
    ratingPeriod: number
}

export interface AffiliationRequestAction {
    action: string;
    userId: string;
}

export interface ProfileInterface {
    cancellations?: {
        cancellationDaysAfterStart: number,
        noticeDaysBeforeEnd: number
    },
    directoryFee?: number;
    stripeVerified?: boolean;
    affiliationRequests?: AffiliationRequest[]
    modalities?: Modality[];
    schedules?: Schedule[];
    publicProfile?: boolean;
    languages?: string[]
    about?: string;
    city?: string;
    comercialName?: string;
    country?: string;
    email: string;
    gender?: number;
    name?: string;
    pictureUrl?: string;
    ssmm?: {
        web: string;
        facebook: string;
        instagram: string;
    };
    surname?: string;
    videoUrl?: string;
    _id: string;
};

export interface RecoveryInterface {
    email: string;
};

export interface SecurityInterface {
    currentPassword: string;
    newPassword: string;
};

export interface ProAffiliationLink {
    _id: string;
    maxStudents: number;
    name: string;
    userId: string;
    code: string;
    paymentRequired: boolean;
    createdAt: string;
}

export interface ProAffiliationLinkRequest {
    maxStudents: number;
    name?: string;
    paymentRequired: boolean;
}

const checkJwt = async () => _.get(await AxiosService.get(Config.server.api.securityApi + 'pro/check', true), 'data', {});
const changeEmail = async (payload: string) => await AxiosService.post(Config.server.api.securityApi + `changeemail`, payload, true);
const changePassword = async (payload: SecurityInterface) => await AxiosService.post(Config.server.api.securityApi + 'changepassword', payload, true);
const getProfile = async (): Promise<ProfileInterface> => _.get(await AxiosService.get(Config.server.api.securityApi + 'getprofile', true), 'data', {});
const login = async (payload: CredentialsInterface) => await AxiosService.post(Config.server.api.securityApi + 'pro/login', payload, false);
const recoveryPassword = async (payload: RecoveryInterface) => await AxiosService.post(Config.server.api.securityApi + `recoverypassword/${payload.email}`, {}, false);
const register = async (payload: CredentialsInterface) => await AxiosService.post(Config.server.api.securityApi + 'pro/register', payload, false);
const updateProfile = async (payload: ProfileInterface): Promise<{ item?: ProfileInterface }> => _.get(await AxiosService.post(Config.server.api.securityApi + 'saveprofile', payload, true), 'data', {});
const makingProfessionalPremiumRole = async () => await AxiosService.put(Config.server.api.securityApi + 'pro/make/premium', {}, true);
const getUserProAffiliationRequests = async (): Promise<AffiliationRequest[]> => _.get(await AxiosService.get(Config.server.api.securityApi + 'pro/affiliation-request', true), 'data', {});
const userProAffiliationRequestAction = async (payload: AffiliationRequestAction) => await AxiosService.post(Config.server.api.securityApi + 'pro/affiliation-request', payload, true);
const getProDirectoryConfig = async (): Promise<DirectoryConfig> => _.get(await AxiosService.get(Config.server.api.securityApi + 'pro/directory-config', true), 'data', {});
const getLastAffiliationLinkByUserId = async (): Promise<ProAffiliationLink | null> => _.get(await AxiosService.get(Config.server.api.securityApi + 'pro/affiliation-link', true), 'data', null);
const createProAffiliationLink = async (payload: ProAffiliationLinkRequest) => _.get(await AxiosService.post(Config.server.api.securityApi + 'pro/affiliation-link', payload, true), 'data', null);

const exports = {
    checkJwt,
    changeEmail,
    changePassword,
    getProfile,
    login,
    recoveryPassword,
    register,
    updateProfile,
    makingProfessionalPremiumRole,
    getUserProAffiliationRequests,
    userProAffiliationRequestAction,
    getProDirectoryConfig,
    getLastAffiliationLinkByUserId,
    createProAffiliationLink
}
export default exports;